(() => {
  if (window.ecomativesCollectionPinInitialized) return;
  window.ecomativesCollectionPinInitialized = true;

  let activeController;

  const getHandle = () => {
    const handle = new URLSearchParams(window.location.search).get('ecomativesby');
    return handle && /^[a-z0-9][a-z0-9-]{0,254}$/i.test(handle) ? handle.toLowerCase() : null;
  };

  const findCard = (grid, handle) =>
    Array.from(grid.querySelectorAll('.grid-product[data-product-handle]'))
      .find((card) => card.dataset.productHandle.toLowerCase() === handle);

  const pinProduct = async () => {
    activeController?.abort();
    const controller = new AbortController();
    activeController = controller;

    const handle = getHandle();
    const section = document.querySelector('.collection-content[data-section-id]');
    const gridBlock = section?.querySelector('[data-ecomatives-page][data-ecomatives-pages]');
    const grid = gridBlock?.querySelector('.collection-grid__wrapper .grid--uniform');
    if (!handle || !grid || Number(gridBlock.dataset.ecomativesPage) !== 1) return;

    const existing = findCard(grid, handle);
    if (existing) {
      grid.prepend(existing);
      return;
    }

    const pages = Number(gridBlock.dataset.ecomativesPages) || 1;
    for (let page = 2; page <= pages; page += 1) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', section.dataset.sectionId);
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) return;

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pageGrid = documentFragment.querySelector('.collection-grid__wrapper .grid--uniform');
        if (!pageGrid || controller.signal.aborted) return;

        const card = findCard(pageGrid, handle);
        if (!card) continue;

        const alreadyLoaded = findCard(grid, handle);
        grid.prepend(alreadyLoaded || card);
        if (!alreadyLoaded && window.theme?.reinitProductGridItem) {
          window.theme.reinitProductGridItem(grid);
        }
        return;
      } catch (error) {
        if (error.name !== 'AbortError') return;
        return;
      }
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.collection-content .pagination a');
    const handle = getHandle();
    if (!link || !handle) return;
    const url = new URL(link.href);
    url.searchParams.set('ecomativesby', handle);
    link.href = url.toString();
  });

  document.addEventListener('collection:reloaded', pinProduct);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinProduct, { once: true });
  } else {
    pinProduct();
  }
})();
